// auth.js
export function isAuthenticated() {
  return sessionStorage.getItem('isAuthenticated') === 'true';
}

export function setAuthenticated(authenticated, username) {
  sessionStorage.setItem('isAuthenticated', authenticated.toString());
}

export function logout() {
  sessionStorage.removeItem('token');
}